
import React from "react";
import { rem_to_px } from "../helper/px";
import { sprintf } from "sprintf-js";
import { transform_point, rotate_about_pos } from "../../lib/matrix";
import {Popup} from "../../lib/onboarding-shared/popup";

class Doughnut extends React.Component {

  // this.props.items[Item]
  // Item: {
  //   color: {r: int, g: int, b: int }
  //   pct: float,
  //   label: label,
  // }
  componentDidMount = () => {
    this.updateCanvas();
  };

  componentDidUpdate = () => {
    this.updateCanvas();
  };

  radialPoint = (theta, radius) => {
    const canvas = this.refs.canvas;
    const width = canvas.offsetWidth;
    const height = canvas.offsetHeight;

    const pt = {
      x: width / 2. + radius,
      y: height / 2.
    };
    return transform_point(
      rotate_about_pos(theta, width / 2., height / 2.),
      pt);
  };

  radialPoint2 = (theta, radius, width_px, height_px) => {
    const pt = {
      x: width_px / 2. + radius,
      y: height_px / 2.
    };
    return transform_point(
      rotate_about_pos(theta, width_px / 2., height_px / 2.),
      pt);
  }

  updateCanvas = () => {
    if (!this.props.items) {
      return;
    }

    const canvas = this.refs.canvas;

    // THIS is how you reset the HTML canvas?? Lame...
    if (canvas) {
      canvas.width = canvas.width;
    }

    const width = canvas.offsetWidth;
    const height = canvas.offsetHeight;
    const maxRadius = Math.abs(Math.min(width, height) / 2.0 - 1.);
    const outerRadius = maxRadius * this.props.outerRad;
    const innerRadius = maxRadius * this.props.innerRad;
    const center = {
      x: width / 2.,
      y: height / 2.,
    };
    const ctx = canvas.getContext('2d');

    let currentArc = 0.;

    // Draw doughnut
    this.props.items.forEach(item => {
      const nextArc = item.pct * 2 * Math.PI + currentArc;

      ctx.fillStyle = sprintf("rgb(%d, %d,%d)",
        item.color.r, item.color.g, item.color.b);

      ctx.beginPath();

      // Outer arc
      ctx.arc(center.x, center.y, outerRadius, currentArc, nextArc);

      // Line
      let toPt = this.radialPoint(nextArc, innerRadius);
      ctx.lineTo(toPt.x, toPt.y);

      // Inner arc
      ctx.arc(center.x, center.y, innerRadius, nextArc, currentArc, true);

      // Line
      toPt = this.radialPoint(currentArc, outerRadius);
      ctx.lineTo(toPt.x, toPt.y);

      ctx.fill();

      currentArc = nextArc;
    });

    // Draw white lines
    currentArc = 0;
    ctx.strokeStyle = "#FFF";
    ctx.lineWidth = 1;

    this.props.items.forEach(item => {
      const fromPt = this.radialPoint(currentArc, outerRadius);
      const toPt = this.radialPoint(currentArc, innerRadius);

      ctx.beginPath();
      ctx.moveTo(fromPt.x, fromPt.y);
      ctx.lineTo(toPt.x, toPt.y);
      ctx.stroke();

      currentArc += item.pct * 2. * Math.PI;

    });


    // Draw labels if they are defined
    currentArc = 0.;
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 1;
    ctx.fillStyle = "#000";
    ctx.textAlign = "center";
    ctx.font = "1rem Helvetica";

    this.props.items.forEach(item => {
      if (item.label) {
        const theta = currentArc + item.pct / 2 * 2 * Math.PI;
        const fromPt = this.radialPoint(theta, outerRadius);
        const toPt = this.radialPoint(theta, maxRadius * this.props.spokeRad);
        ctx.beginPath();
        ctx.moveTo(fromPt.x, fromPt.y);
        ctx.lineTo(toPt.x, toPt.y);
        ctx.stroke();

      }
      currentArc += item.pct * 2. * Math.PI;
    })
  };

  dumpLabelPopups = () => {
    const result = [];
    const font_px = rem_to_px(1);

    const size_rem = this.props.sizeRem;
    const size_px = rem_to_px(size_rem);

    const canvas = this.refs.canvas;
    if (!canvas) {
      // TODO: Need to find a better way to trigger a re-render.
      // canvas reference is not defined during SSR.
      this.forceUpdate();
      return result;
    }
    const ctx = canvas.getContext('2d');
    const maxRadius = size_px / 2.0 - 1.;

    let currentArc = 0.;

    const spanStyle = {
      padding: "0.5rem",
      whiteSpace: "nowrap",
    }

    this.props.items.forEach((item, index) => {
      if (item.label) {
        const theta = currentArc + item.pct / 2 * 2 * Math.PI;
        let radius;
        if (typeof this.props.labelRad === "function") {
          radius = this.props.labelRad(theta, item.label);
        } else if (typeof this.props.labelRad === "number") {
          radius = this.props.labelRad;
        } else {
          console.log("labelRad is ", typeof this.props.labelRad);
          radius = 1.;
        }

        const labelPt = this.radialPoint2(theta, maxRadius * radius, size_px, size_px);
        const measure = ctx.measureText(item.label);

        const style = {
          top: labelPt.y - measure.actualBoundingBoxAscent - 0.5 * font_px,
          left: labelPt.x - measure.actualBoundingBoxLeft - 0.5 * font_px,
          position: "absolute",
          display: "inline-block",
          zIndex: "5",
        }
        result.push( (
          <Popup
            key={index}
            style={style}>
            <span style={spanStyle}>{item.label}</span>
          </Popup>
        ))
      }
      currentArc += item.pct * 2. * Math.PI;
    });
    return result;
  }

  popupTest = () => {
    const result = [];

    const size_rem = this.props.sizeRem;
    const size_px = rem_to_px(size_rem);

    const n = 5;

    for(let i=0; i <= n; i++) {
      for(let j=0; j <= n; j++) {
        const x = size_px / n * i;
        const y = size_px / n * j;
        const style = {
          top: sprintf("%fpx", y),
          left: sprintf("%fpx", x),
          position: "absolute",
          display: "inline-block",
        }
        result.push( (
          <Popup
            key={i*20 + j}
            style={style}>
            <span>{sprintf("%f %f", x, y)}</span>
          </Popup>
        ))

      }
    }
    return result;
  }

  generateCanvasSizeRem = (size_rem) => {
    return sprintf("%drem", size_rem);
  }

  render = () => {

    const size_rem = this.props.sizeRem;
    const size_px = rem_to_px(size_rem);
    const maxCanvasSize = this.generateCanvasSizeRem(size_rem);
    const minCanvasSize = this.generateCanvasSizeRem(size_rem - 10);

    const containerStyle = {
      maxWidth: maxCanvasSize,
      maxHeight: maxCanvasSize,
      minWidth: minCanvasSize,
      minHeight: minCanvasSize,
      position: "relative",
      margin: "0 auto",
      ...this.props.containerStyle,
    };
    const canvasStyle = {
      width: sprintf("%dpx", size_px),
      height: "100%",
    };
    const overlayStyle = {
      width: "100%",
      height: "100%",
      position: "absolute",
      top: "0",
      left: "0",
      ...this.props.overlayStyle,
      //background: "rgba(255, 0, 0, 0.2)"
    };

    return (
      <div style={containerStyle}>
        <canvas
          ref="canvas"
          style={canvasStyle}
          width={size_px}
          height={size_px}/>
        <div style={overlayStyle}>
          { this.dumpLabelPopups() }
          { /* this.popupTest() */ }
        </div>
      </div>
    );
  }
}

export { Doughnut };
